// extracted by mini-css-extract-plugin
module.exports = {"declaration":"fkOjOKEgi13BRf4SmMj0Cw==","footer":"_4Tf9ZPw2sSHCItPzuoqo0Q=="};